import { SubLayout } from '@/components/layouts'
const routes = {
  path: '/stock',
  redirect: '/stock/stockList',
  component: SubLayout,
  children: [
    {
      path: 'stockList',
      name: 'stockList',
      meta: {
        title: '库存管理'
      },
      component: () => import('@/views/stock/Index')
    }
  ]
}

export default routes
